// import { ScrollControls } from "@react-three/drei";
// import { Canvas } from "@react-three/fiber";
// import { Experience } from "./components/Experience";
// import { Overlay } from "./components/Overlay";
// import { usePlay } from "./contexts/Play";

// function RoadMap() {
//   const { play, end } = usePlay();

//   return (
//     <>
//       <Canvas>
//         <color attach="background" args={["#ececec"]} />
//         <ScrollControls
//           pages={play && !end ? 20 : 0}
//           damping={0.5}
//           style={{
//             top: "10px",
//             left: "0px",
//             bottom: "10px",
//             right: "10px",
//             width: "auto",
//             height: "auto",
//             animation: "fadeIn 2.4s ease-in-out 1.2s forwards",
//             opacity: 0,
//           }}
//         >
//           <Experience />
//         </ScrollControls>
//       </Canvas>
//       <Overlay />
//     </>
//   );
// }

// export default RoadMap;



import { Canvas } from "@react-three/fiber";
import { ScrollControls } from "@react-three/drei";
import Overlay from "./components/Overlay";
import { usePlay } from "./contexts/Play";
import { Experience1 } from "./components/Experience1";

function RoadMap() {
  const { play, end } = usePlay();

  return (
    <>
      <Canvas>
        <color attach="background" args={["#ececec"]} />
        <ScrollControls
          pages={play && !end ? 20 : 0}
          damping={0.5}
          style={{
            top: "10px",
            left: "0px",
            bottom: "10px",
            right: "10px",
            width: "auto",
            height: "auto",
            animation: "fadeIn 2.4s ease-in-out 1.2s forwards",
            opacity: 0,
          }}
        >
          <ambientLight intensity={1} />
          <directionalLight position={[10, 10, 10]} intensity={1.5} />
          <Experience1 />
        </ScrollControls>
      </Canvas>
      <Overlay />
    </>
  );
}

export default RoadMap;
